module.exports = __webpack_public_path__ + "img/delete-icon.d0cdd02b.svg";